import React from 'react';
import { useSEOKeywords } from '../../hooks/useSEOKeywords';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { useAlgoliaDataStateContext } from '../../hooks/useAlgoliaDataStateContext';
import { clsx } from '../../../utils/clsx';
import { MEDIA_BREAKPOINTS } from '../../../constants/MEDIA_BREAKPOINTS';
export const NbOfItems = () => {
    const { nbHits } = useAlgoliaDataContext();
    const { loading } = useAlgoliaDataStateContext();
    const { kw1 } = useSEOKeywords();
    return loading
        ? React.createElement("span", { className: clsx('d:block skeleton bdrs:2 fx:none fz fz:12 lts:10p', MEDIA_BREAKPOINTS.XL_UP.matches ? 'ml:auto' : 'm:auto'), style: { height: '1.375em', width: '10%' } })
        : React.createElement("span", { "data-cy-test": 'CollectionItemsCount', className: "ml:auto text:uppercase fx:none text:center d:block fz:12 lts:10p" },
            nbHits,
            " ",
            kw1,
            nbHits > 1 && kw1[kw1.length - 1] !== 's' ? 's' : '');
};
